import { dataHooks } from '@wix/data-hooks';

export const errorMessagesDataHooks = dataHooks<{
  error: { index: number }; // it's possible to display more than one error. Use index to find error from the list
  errorText: { index: number };
  learnMoreTextButton: { index: number };
  fileNames: { index: number };
}>('ErrorMessages');
